import React from "react";
import styled from "styled-components";
import IcoMoon, { IconProps } from "react-icomoon";

import { Colors } from "src/library/utils";

import iconSet from "./selection.json";
import type { Icons } from "./types";

const IconWrapper = styled(IcoMoon)<{
  $hoverColor: keyof Colors;
  $fillColor: keyof Colors;
  cursor?: "pointer" | "default";
}>`
  overflow: visible;
  fill: ${({ theme, $fillColor }) => theme.colors[ $fillColor ]} !important;
  :hover {
    cursor: ${({ cursor }) => cursor ? cursor : "inherit"};
    transition: 0.2s ease;
    fill: ${({ theme, $hoverColor }) => theme.colors[ $hoverColor ]} !important;
  }
`;

const Icon: React.ReactFCWithChildren<IIconWrapperProps> = ({
  size, onClick, $fillColor, $hoverColor, cursor, ref: _ref, ...rest
}) => {
  return (
    <IconWrapper
      // horrible but the only way to override the icon display: inline-block styling
      style={{ display: "" }}
      iconSet={iconSet}
      onClick={onClick}
      cursor={cursor}
      $fillColor={$fillColor || "primaryDark"}
      $hoverColor={$hoverColor || $fillColor || "primaryDark"}
      size={size || 25}
      {...rest}
    />
  );
};

interface IIconWrapperProps extends IconProps {
  icon: Icons;
  cursor?: "pointer" | "default";
  size?: number;
  $fillColor?: keyof Colors;
  $hoverColor?: keyof Colors;
  onClick?: () => void;
  className?: string;
}

export default Icon;
